import { render, staticRenderFns } from "./MitManagePeopleList2.vue?vue&type=template&id=83c8344e&scoped=true"
import script from "./MitManagePeopleList2.vue?vue&type=script&lang=js"
export * from "./MitManagePeopleList2.vue?vue&type=script&lang=js"
import style0 from "./MitManagePeopleList2.vue?vue&type=style&index=0&id=83c8344e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c8344e",
  null
  
)

export default component.exports